import Quill from 'quill';

const Picker = Quill.import('ui/picker');

class MtPicker extends Picker {
  constructor(select) {
    super(select);
    this.container.classList.add('ql-bar');
  }
}

export default MtPicker;
